<div class="spinner-container mod">
  <div class="spinner-content">
    <div class="spinner-div">
      <mat-spinner color="accent"></mat-spinner>
    </div>
    <div class="text" *ngIf="!!message">{{message}}</div>
  </div>
</div>
